import { Outlet } from "react-router-dom";

const TimesheetRoot = () => {
  return <Outlet />;
};

export default TimesheetRoot;
